import { formatDate } from "../../framework/utils/format-date/format-date.js";
import { IconCalendarToday } from "../icon/variants/IconCalendarToday.js";
import { IconUnfoldMore } from "../icon/variants/IconUnfoldMore.js";
import date_picker_module_default from "./date-picker.module.js";
import { Fragment, jsx, jsxs } from "react/jsx-runtime";
import { useTranslation } from "react-i18next";
import { DateAdapter } from "@myphx-engineering/date-utils/client";
import "@mantine/dates/styles.css";
import { DatePickerInput } from "@mantine/dates";

//#region src/components/date-picker/DatePickerInput.tsx
const DatePickerInput$1 = ({ label, placeholder, value, required, error, disabled, onChange, maxDate, minDate, friendlyLabels = false, "data-testid": testId }) => {
	const hasValue = !!value?.[0] && !!value?.[1];
	const { t } = useTranslation("pds");
	const valueFormatter = friendlyLabels ? ({ type, date, locale }) => {
		if (type === "range" && Array.isArray(date)) {
			const [startDate, endDate] = date;
			if (!startDate || !endDate) return "";
			const endPlainDate = DateAdapter.plainDateFromInput(endDate);
			const todayPlainDate = DateAdapter.plainDateToday();
			const isEndToday = DateAdapter.isSameDay(endPlainDate, todayPlainDate);
			const formatOptions = {
				month: "short",
				day: "numeric",
				year: "numeric"
			};
			const startPlainDate = DateAdapter.plainDateFromInput(startDate);
			return `${DateAdapter.formatPlainDate(startPlainDate, locale, formatOptions)} - ${isEndToday ? t("datePicker.today") : DateAdapter.formatPlainDate(endPlainDate, locale, formatOptions)}`;
		}
		return "";
	} : void 0;
	const modalProps = {
		size: void 0,
		padding: "md",
		styles: {
			inner: {
				display: "flex",
				alignItems: "center",
				justifyContent: "center",
				padding: "var(--mantine-spacing-md)"
			},
			body: {
				display: "flex",
				justifyContent: "center",
				width: "100%",
				overflowX: "auto"
			},
			content: {
				minWidth: "min-content",
				width: "100%",
				overflow: "visible"
			},
			header: { padding: 0 }
		}
	};
	return /* @__PURE__ */ jsx(DatePickerInput, {
		label: hasValue && label,
		placeholder,
		value,
		onChange,
		required,
		type: "range",
		labelProps: { "data-floating": hasValue },
		radius: "xxs",
		size: "xl",
		classNames: date_picker_module_default,
		descriptionProps: { className: disabled ? date_picker_module_default.descriptionDisabled : date_picker_module_default.description },
		inputWrapperOrder: error ? [
			"label",
			"input",
			"error"
		] : [
			"label",
			"input",
			"description"
		],
		valueFormat: "MMM D, YYYY",
		valueFormatter,
		firstDayOfWeek: 0,
		getDayProps: (_) => ({ weekend: false }),
		maxDate,
		minDate,
		withCellSpacing: false,
		monthLabelFormat: renderMonthLabel,
		dropdownType: "modal",
		modalProps,
		"data-testid": testId,
		rightSection: !hasValue ? /* @__PURE__ */ jsx(IconCalendarToday, { style: { marginRight: "var(--mantine-spacing-sm)" } }) : void 0,
		rightSectionPointerEvents: !hasValue ? "none" : void 0,
		clearable: hasValue
	});
};
function renderMonthLabel(date) {
	return /* @__PURE__ */ jsxs(Fragment, { children: [formatDate(/* @__PURE__ */ new Date(`${date}T00:00:00`), {
		month: "long",
		year: "numeric"
	}), /* @__PURE__ */ jsx(IconUnfoldMore, { width: "xs" })] });
}

//#endregion
export { DatePickerInput$1 as DatePickerInput };